__webpack_require__.p = "/men-quiz-gatsby-assets/hair/men/quiz/";